// const baseUrl= `http://localhost:3876`;
const baseUrl= ``;


export {baseUrl}